import {Ref, useMemo} from 'react';

import {useDOMRef} from 'utils/recommendation-utils/recommendations';

import {UseImageCardProps} from './types';

export interface UseImageCardReturn extends UseImageCardProps {
  getRootProps: Record<string, string>;
  domRef: React.RefObject<HTMLElement>;
}

export function useImageCard(originalProps: UseImageCardProps): UseImageCardReturn {
  const {ref, component, ...otherProps} = originalProps;

  const domRef = useDOMRef(ref as Ref<HTMLElement | null> | undefined);

  const getRootProps = useMemo(() => {
    return {
      'data-testid': 'image-root'
    };
  }, []);

  return {component, getRootProps, domRef, ...otherProps};
}
